import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SearchInputModule } from '@gspwidget/util';
import { DraggablePortletListComponent } from './draggable-portlet-list.component';

@NgModule({
  declarations: [
    DraggablePortletListComponent,
  ],
  imports: [
    CommonModule,
    NzMenuModule,
    TranslateModule,
    NzToolTipModule,
    SearchInputModule
  ],
  exports: [
    DraggablePortletListComponent,
  ]
})
export class DraggablePortletListModule {
}
